import React from 'react';
import cx from 'classnames';
import styles from './SectionContentsHero.module.scss';

function SectionContentsHero({heading, subHeading, actions, className}) {
  return (
    <div className={cx(styles['hero'], className)}>
      <h1>{heading}</h1>
      <h5>{subHeading}</h5>
      {!!actions && <div>{actions}</div>}
    </div>
  );
}

export default SectionContentsHero;
